export default "__VITE_ASSET__yYDsPcPu__"